// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Q_et","choiceBoxes":"toolbarselects_choiceBoxes__12UxZ","simpleField":"toolbarselects_simpleField__1lmaX"};